export default __webpack_public_path__ + "static/media/2002.34ab594e.png";